import { faMobileAlt, faTabletAlt, faMobileScreenButton } from '@fortawesome/free-solid-svg-icons';

export const ICONS = {
  mobile: faMobileAlt,
  tablet: faTabletAlt,
  emptySessions: faMobileScreenButton,
  emptyDevices: faTabletAlt,
};

export const ERROR_MESSAGES = {
  FETCH_DEVICES: 'Failed to fetch devices. Please try again later.',
  FETCH_SESSIONS: 'Failed to fetch active sessions. Please try again later.',
  GENERIC: 'An error occurred. Please try again.',
};

export const LOADING_MESSAGES = {
  DEVICES: 'Loading devices...',
  SESSIONS: 'Loading active sessions...',
  BOTH: 'Loading Active Sessions & Devices...',
};

export const SUCCESS_MESSAGES = {
  REFRESHED: 'Data refreshed successfully',
};

export const BADGE_COLORS = {
  ACTIVE: 'success',
  REGISTERED: 'processing',
};

export const EMPTY_STATES = {
  NO_SESSIONS: 'No active sessions found',
  NO_DEVICES: 'No devices found',
};
